module.exports = __webpack_public_path__ + "static/media/figure-carving-leatherworking-tool.5b8ee93b.webp";